module.exports = __webpack_public_path__ + "img/slide02.7750002d.jpg";